import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface Warehouse {
  id: number;
  name: string;
  code?: string | null;
  address?: string | null;
  responsible?: string | null;
  created: string;
  lastModified: string;
}

export interface WarehousePayload {
  name: string;
  code?: string | null;
  address?: string | null;
  responsible?: string | null;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export function getWarehouses(): Promise<Warehouse[]> {
  return request<Warehouse[]>("/api/warehouses");
}

export function getWarehouseById(warehouseId: number): Promise<Warehouse> {
  return request<Warehouse>(`/api/warehouses/${warehouseId}`);
}

export function createWarehouse(payload: WarehousePayload): Promise<Warehouse> {
  return request<Warehouse>("/api/warehouses", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateWarehouse(
  warehouseId: number,
  payload: WarehousePayload,
): Promise<Warehouse> {
  return request<Warehouse>(`/api/warehouses/${warehouseId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
